import { render } from "./ThankYouOrderDetails.vue?vue&type=template&id=710d04b6&scoped=true&ts=true"
import script from "./ThankYouOrderDetails.vue?vue&type=script&lang=ts"
export * from "./ThankYouOrderDetails.vue?vue&type=script&lang=ts"

import "./ThankYouOrderDetails.vue?vue&type=style&index=0&id=710d04b6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710d04b6"]])

export default __exports__